import { RadioGroup, Stack, useColorMode, VStack } from '@chakra-ui/react'
import { Body, Radio, SelectOption } from '@missionlabs/react'
import { HuntGroupCallRouteSteering } from '@missionlabs/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { UnansweredOptions } from './UnansweredOptions'

interface Props {
    inHoursUnanswered?: HuntGroupCallRouteSteering | 'ring_out'
    audioClipsWithDefault: SelectOption[]
    handleChange(name: string, value: string): void
}

export const TeamUnanswered: FC<Props> = ({
    inHoursUnanswered,
    audioClipsWithDefault,
    handleChange
}) => {
    const { t } = useTranslation()
    const { colorMode } = useColorMode()

    return (
        <VStack spacing="10px" align="inherit">
            <Body sx={{ color: `${colorMode}.coolGrey.80` }}>
                {t('admin.teams.form.inHoursUnanswered_text')}
            </Body>
            <RadioGroup
                minH="unset"
                value={inHoursUnanswered}
                onChange={value => handleChange('callRoute.inHoursUnanswered', value)}
            >
                <Stack spacing={3}>
                    <Radio value="ring_out">
                        {t('admin.teams.form.inHoursUnanswered_ring_out')}
                    </Radio>
                    <Radio value="voicemail">
                        {t('admin.teams.form.inHoursUnanswered_voicemail')}
                    </Radio>
                    {inHoursUnanswered === 'voicemail' && (
                        <UnansweredOptions
                            mode="audioclip"
                            name="voicemail.customGreetingURL"
                            options={audioClipsWithDefault}
                        />
                    )}
                    <Radio value="voicemail_no_message">
                        {t('admin.teams.form.inHoursUnanswered_voicemail_no_message')}
                    </Radio>
                    {inHoursUnanswered === 'voicemail_no_message' && (
                        <UnansweredOptions
                            mode="audioclip"
                            name="voicemail.customGreetingNoMessageURL"
                            options={audioClipsWithDefault}
                        />
                    )}
                    <Radio value="redirect_internal">
                        {t('admin.teams.form.inHoursUnanswered_redirect_internal')}
                    </Radio>
                    {inHoursUnanswered === 'redirect_internal' && (
                        <UnansweredOptions mode="internal" name="unansweredRedirectInternal" />
                    )}
                    <Radio value="redirect">
                        {t('admin.teams.form.inHoursUnanswered_redirect')}
                    </Radio>
                    {inHoursUnanswered === 'redirect' && (
                        <UnansweredOptions mode="numberE164" name="unansweredRedirect" />
                    )}
                </Stack>
            </RadioGroup>
        </VStack>
    )
}
